import React from 'react'
import { useState, useEffect } from 'react';
import { Row, Col, Button, Label, Input, Form, FormGroup, Collapse, Card, CardBody, CardHeader, } from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

const Achievements = ({ itemPopupAchievements, handleItemPopupAchievements }) => {
    const [isOpen, setIsOpen] = useState(itemPopupAchievements.isExpand == true ? true : false);
    const [isIconUp, setIsIconUp] = useState(itemPopupAchievements.isExpand == true ? true :false);

    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    return (
        <Card>
            <CardHeader className="card-header-click"  onClick={toggle}>
                <Row>
                    <Col sm="11">
                        <h6>Achievements</h6>
                    </Col>
                    <Col sm="1"  className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                </Row>
            </CardHeader>
            <Collapse isOpen={isOpen}>
            <CardBody>               
                <Row>
                    <Col sm="1">
                        <input className="islargeEnterprise form-check-input" name="isAchievementsNotes" type="checkbox" checked={itemPopupAchievements.isAchievementsNotes} onChange={handleItemPopupAchievements} />

                    </Col>
                    <Col sm="5">
                        <label>
                            Is Achievement of Note?
                        </label>
                    </Col>
                    <Col sm="6">
                        <FormGroup>
                            <Label>Achievement of Note Comments</Label>
                                <Input type="textarea" name="achievementsComment" id="achievementsComment" value={itemPopupAchievements.achievementsComment} onChange={handleItemPopupAchievements} />
                        </FormGroup>
                    </Col>

                </Row>
                </CardBody>
            </Collapse>
        </Card> 
    )

}
export default Achievements